/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  events: {},
  loading: false,
  error: null,
};

const segmentSlice = createSlice({
  name: "segmentEvents",
  initialState,
  reducers: {
    fetchEventsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchEventsSuccess: (state, action) => {
      state.loading = false;
      state.events = action.payload;
    },
    fetchEventsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const getSegmentEvents = (state) => state.segmentEvents.events;

export const { fetchEventsStart, fetchEventsSuccess, fetchEventsFailure } =
  segmentSlice.actions;

export default segmentSlice.reducer;
